const AUTO_SAVE_INTERVAL = 10 // seconds
const TRIAL_DAYS = 15
const MARKETPLACE_DISCOUNT = 0.5

export {
  AUTO_SAVE_INTERVAL,
  TRIAL_DAYS,
  MARKETPLACE_DISCOUNT
}
